import LoadingSpinner from '@/components/LoadingSpinner';
import { httpStatusCodes } from '@/helpers/constants';
import { useFetchFoundUrls } from '@/http/queries';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import IssueExportForm from '../IssueExportForm';
import {
  buildBulletListAdf,
  buildCodeBlockAdf,
  buildLinkAdf,
  formattedText,
  subHeadingWithTextAdf,
} from './adfUtils';

export function BrokenLinksExport({
  todosToExport,
  jiraProject,
  jiraUsers,
  linkedJiraUserID,
  issueExportFormRef,
}) {
  const { t } = useTranslation();
  const url = todosToExport[0].props.url;
  const { data, isLoading } = useFetchFoundUrls();

  const urlDataEntry = useMemo(() => {
    if (isLoading || !data) return null;

    const { uniqueUrls, urlDetails } = data;

    const dataEntryKey = Object.keys(uniqueUrls).find(
      (key) => uniqueUrls[key] === url,
    );

    const { foundOn, htmls, status: urlStatus } = urlDetails[dataEntryKey];

    let foundOnUrlsTextLength = 0;
    const foundOnUrls = (
      foundOn?.map((index) => uniqueUrls[index]) || []
    ).filter((url) => {
      const isValid = !!url && foundOnUrlsTextLength < 20000;
      if (isValid) {
        foundOnUrlsTextLength += url.length;
      }
      return isValid;
    });

    let status = urlStatus;
    if (urlStatus.includes?.('Unknown Error')) {
      status = 'Unknown Error';
    }

    status =
      status + httpStatusCodes[status] ? `(${httpStatusCodes[status]})` : '';

    return { url, foundOnUrls, html: htmls?.[0], status };
  }, [data, isLoading, url]);

  if (!jiraUsers || isLoading || !urlDataEntry) return <LoadingSpinner />;

  const jiraBodyDescripiton = [];

  jiraBodyDescripiton.push(
    subHeadingWithTextAdf(t('url'), urlDataEntry?.url, urlDataEntry?.url),
  );

  // // Description

  jiraBodyDescripiton.push(
    subHeadingWithTextAdf(`${t('url')} ${t('status')}`, urlDataEntry?.status),
  );

  if (urlDataEntry?.html && urlDataEntry.html.length < 2000) {
    jiraBodyDescripiton.push(formattedText('HTML', 'strong'));
    jiraBodyDescripiton.push(buildCodeBlockAdf(urlDataEntry.html, 'xml'));
  }

  if (urlDataEntry?.foundOnUrls?.length > 0) {
    jiraBodyDescripiton.push(
      formattedText(
        `${t('linkFoundOn')} (${urlDataEntry?.foundOnUrls?.length})`,
        'strong',
      ),
    );
    jiraBodyDescripiton.push(
      buildBulletListAdf(
        urlDataEntry?.foundOnUrls.map((url) =>
          buildLinkAdf(urlDataEntry?.url, urlDataEntry?.url, true),
        ),
      ),
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <IssueExportForm
        ref={issueExportFormRef}
        todosToExport={todosToExport}
        jiraProject={jiraProject}
        jiraBodyDescripiton={jiraBodyDescripiton}
        jiraUsers={jiraUsers}
        linkedJiraUserID={linkedJiraUserID}
      />
    </Box>
  );
}
